import React from 'react';
import _ from '@lodash';
import { Divider, GlobalStyles } from '@mui/material';

import FuseNavHorizontalLayout1 from './horizontal/FuseNavHorizontalLayout1';
import FuseNavVerticalLayout1 from './vertical/FuseNavVerticalLayout1';
import FuseNavVerticalLayout2 from './vertical/FuseNavVerticalLayout2';
import FuseNavHorizontalCollapse from './horizontal/types/FuseNavHorizontalCollapse';
import FuseNavHorizontalGroup from './horizontal/types/FuseNavHorizontalGroup';
import FuseNavHorizontalItem from './horizontal/types/FuseNavHorizontalItem';
import FuseNavHorizontalLink from './horizontal/types/FuseNavHorizontalLink';
import FuseNavVerticalCollapse from './vertical/types/FuseNavVerticalCollapse';
import FuseNavVerticalGroup from './vertical/types/FuseNavVerticalGroup';
import FuseNavVerticalItem from './vertical/types/FuseNavVerticalItem';
import FuseNavVerticalLink from './vertical/types/FuseNavVerticalLink';
import { registerComponent } from './FuseNavItem';
import type { FuseNavItemType } from './types/FuseNavItemType';

const inputGlobalStyles = (
	<GlobalStyles
		styles={theme => ({
			'.popper-navigation-list': {
				'& .fuse-list-item': {
					padding: '8px 12px 8px 12px',
					height: 40,
					minHeight: 40,
					'& .fuse-list-item-text': {
						padding: '0 0 0 8px'
					}
				},
				'&.dense': {
					'& .fuse-list-item': {
						minHeight: 32,
						height: 32,
						'& .fuse-list-item-text': {
							padding: '0 0 0 8px'
						}
					}
				}
			}
		})}
	/>
);

/*
Register Fuse Navigation Components
 */
registerComponent('vertical-group', FuseNavVerticalGroup);
registerComponent('vertical-collapse', FuseNavVerticalCollapse);
registerComponent('vertical-item', FuseNavVerticalItem);
registerComponent('vertical-link', FuseNavVerticalLink);
registerComponent('horizontal-group', FuseNavHorizontalGroup);
registerComponent('horizontal-collapse', FuseNavHorizontalCollapse);
registerComponent('horizontal-item', FuseNavHorizontalItem);
registerComponent('horizontal-link', FuseNavHorizontalLink);
registerComponent('vertical-divider', () => <Divider className="my-16" />);
registerComponent('horizontal-divider', () => <Divider className="my-16" />);

export interface FuseNavigationProps {
	className?: string;
	navigation: any[];
	layout: 'horizontal' | 'vertical' | 'vertical-2';
	onItemClick: (item: FuseNavItemType) => void;
	selectedId?: string;
	firstLevel?: boolean;
	active?: boolean;
	dense?: boolean;
}

function FuseNavigation({
	className,
	navigation,
	layout = 'vertical',
	onItemClick,
	selectedId,
	firstLevel = false,
	active,
	dense = false
}: FuseNavigationProps) {
	const options = { className, navigation, layout, active, dense, firstLevel, selectedId, onItemClick };

	if (navigation.length > 0) {
		return (
			<>
				{inputGlobalStyles}
				{layout === 'horizontal' && <FuseNavHorizontalLayout1 {...options} />}
				{layout === 'vertical' && <FuseNavVerticalLayout1 {...options} />}
				{layout === 'vertical-2' && <FuseNavVerticalLayout2 {...options} />}
			</>
		);
	}
	return null;
}

export default React.memo(FuseNavigation);
